import { useBreakpointIndex } from '@theme-ui/match-media';
import React, { useEffect, useRef, useState } from 'react';
import { HOST_ENV } from '../../api/wagtail';
import { PRINTED_PAGES } from '../../consts/component-types';
import {
  FREE_USER_LEVEL,
  TRIAL_USER_LEVEL,
} from '../../consts/restrictionTypes';
import {
  MOBILE_BREAKPOINT_INDEX,
  NOT_COVERED_TITLE_PERCENTS,
} from '../../consts/style-consts';
import { FREE_TRIAL_URL } from '../../consts/urls';
import usePrint from '../../hooks/usePrint';
import LinkImage from '../../shared-styled/blocks/ImageBlocks';
import { NoUnderlineAnchor } from '../../shared-styled/typography/Anchors';
import styles from '../../styles/print-media.module.css';
import { IS_NEXT_EXPORT } from '../../utils/export';
import { strictMathUrl } from '../../utils/matchUrl';
import UpgradeTrialButton from '../GatedBlock/UpgradeTrialButton/UpgradeTrialButton';
import { useGlobalContext } from '../GlobalContextProvider/GlobalContextProvider';
import HeaderCategoryNavigation from '../HeaderCategoryNavigation/HeaderCategoryNavigation';
import PrintButton from '../PrintButton/PrintButton';
import SearchBar from '../SearchBar/SearchBar';
import UniversalLink from '../UniversalLink/UniversalLink';

import {
  AlignedGreenButton,
  Auth,
  AuthButton,
  CloseLoginIcon,
  CloseNavIcon,
  Container,
  LogoWrapper,
  MidWrapper,
  SearchAndPrintWrapper,
  NavIcon,
  MenuLabelContainer,
  IconContainer,
  MenuLabel,
} from './Header.styled';

const mpLogo = IS_NEXT_EXPORT
  ? 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQ1IiBoZWlnaHQ9Ijk0LjAwMDAwMDAwMDAwMDAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHZlcnNpb249IjEuMSI+CgogPGc+CiAgPHRpdGxlPkxheWVyIDE8L3RpdGxlPgogIDxnIGlkPSJzdmdfMSI+CiAgIDxnIGlkPSJzdmdfMiI+CiAgICA8ZyBpZD0ic3ZnXzMiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXciIGNsYXNzPSJzdDAiPgogICAgIDxwYXRoIGlkPSJzdmdfNCIgZmlsbD0iIzFDMzAzNyIgZD0ibTM3LjU1NTU1LDQ4LjE1NTU1bDAsLTIyLjRsLTcuOSwyMi40bC00LjgsMGwtNy45LC0yMi40bDAsMjIuNGwtMTAuNywwbDAsLTM1LjVsMTQuOCwwbDYuMiwxOC4xbDYuMiwtMTguMWwxNC44LDBsMCwzNS40bC0xMC43LDBsMCwwLjF6IiBjbGFzcz0ic3QxIi8+CiAgICAgPHBhdGggaWQ9InN2Z181IiBmaWxsPSIjMUMzMDM3IiBkPSJtNTMuOTU1NTUsNDguMTU1NTVsMCwtMzUuNWwxMC43LDBsMCwzNS40bC0xMC43LDBsMCwwLjF6IiBjbGFzcz0ic3QxIi8+CiAgICAgPHBhdGggaWQ9InN2Z182IiBmaWxsPSIjMUMzMDM3IiBkPSJtNzAuNDU1NTUsNDguMTU1NTVsMCwtMzUuNWwxMC43LDBsMCwyNi4xbDEzLjQsMGwwLDkuNGwtMjQuMSwweiIgY2xhc3M9InN0MSIvPgogICAgIDxwYXRoIGlkPSJzdmdfNyIgZmlsbD0iIzFDMzAzNyIgZD0ibTk4Ljk1NTU1LDQ4LjE1NTU1bDAsLTM1LjVsMTAuNywwbDAsMzUuNGwtMTAuNywwbDAsMC4xeiIgY2xhc3M9InN0MSIvPgogICAgIDxwYXRoIGlkPSJzdmdfOCIgZmlsbD0iIzFDMzAzNyIgZD0ibTEyMy4wNTU1NSw0OC4xNTU1NWwwLC0yNi4xbC05LjUsMGwwLC05LjRsMjkuNywwbDAsOS40bC05LjUsMGwwLDI2LjFsLTEwLjcsMHoiIGNsYXNzPSJzdDEiLz4KICAgICA8cGF0aCBpZD0ic3ZnXzkiIGZpbGw9IiMxQzMwMzciIGQ9Im0xNjguMDU1NTUsNDguMTU1NTVsLTEuNCwtNC42bC0xMy42LDBsLTEuNCw0LjZsLTExLjYsMGwxMy4xLC0zNS40bDEzLjQsMGwxMy4xLDM1LjRsLTExLjYsMHptLTguMiwtMjZsLTQsMTIuNWw4LjEsMGwtNC4xLC0xMi41eiIgY2xhc3M9InN0MSIvPgogICAgIDxwYXRoIGlkPSJzdmdfMTAiIGZpbGw9IiMxQzMwMzciIGQ9Im0yMDEuMDU1NTUsNDguMTU1NTVsLTQuOSwtMTEuNGwtMy45LDBsMCwxMS40bC0xMC43LDBsMCwtMzUuNWwxOC45LDBjOC4zLDAgMTIuOCw1LjUgMTIuOCwxMi4yYzAsNi4xIC0zLjYsOS40IC02LjQsMTAuN2w2LjQsMTIuNWwtMTIuMiwwbDAsMC4xem0tMi4yLC0yNi41bC02LjUsMGwwLDYuMmw2LjUsMGMxLjgsMCAzLjUsLTEuMiAzLjUsLTMuMWMwLC0yIC0xLjcsLTMuMSAtMy41LC0zLjF6IiBjbGFzcz0ic3QxIi8+CiAgICAgPHBhdGggaWQ9InN2Z18xMSIgZmlsbD0iIzFDMzAzNyIgZD0ibTIyNS45NTU1NSw0OC4xNTU1NWwwLC0xNC4xbC0xMy4zLC0yMS40bDEyLjEsMGw2LjYsMTJsNi41LC0xMmwxMi4xLDBsLTEzLjIsMjEuNGwwLDE0LjFsLTEwLjgsMHoiIGNsYXNzPSJzdDEiLz4KICAgIDwvZz4KICAgIDxnIGlkPSJzdmdfMTIiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXciIGNsYXNzPSJzdDAiPgogICAgIDxwYXRoIGlkPSJzdmdfMTMiIGZpbGw9IiMxQzMwMzciIGQ9Im02LjE1NTU1LDg3LjE1NTU1bDAsLTM1LjRsMTguOSwwYzguMywwIDEyLjgsNS41IDEyLjgsMTIuMmMwLDYuNiAtNC41LDExLjkgLTEyLjgsMTEuOWwtOC4yLDBsMCwxMS40bC0xMC43LDBsMCwtMC4xem0xNy42LC0yNi41bC02LjgsMGwwLDYuMmw2LjgsMGMxLjgsMCAzLjIsLTEuMiAzLjIsLTMuMWMwLC0xLjkgLTEuNCwtMy4xIC0zLjIsLTMuMXoiIGNsYXNzPSJzdDEiLz4KICAgICA8cGF0aCBpZD0ic3ZnXzE0IiBmaWxsPSIjMUMzMDM3IiBkPSJtNDEuMzU1NTUsODcuMTU1NTVsMCwtMzUuNGwyNi45LDBsMCw4LjlsLTE2LjIsMGwwLDQuMWwxNS44LDBsMCw4LjlsLTE1LjgsMGwwLDQuNWwxNi4yLDBsMCw4LjlsLTI2LjksMGwwLDAuMXoiIGNsYXNzPSJzdDEiLz4KICAgICA8cGF0aCBpZD0ic3ZnXzE1IiBmaWxsPSIjMUMzMDM3IiBkPSJtOTIuNTU1NTUsODcuMTU1NTVsLTQuOSwtMTEuNGwtMy45LDBsMCwxMS40bC0xMC43LDBsMCwtMzUuNGwxOC45LDBjOC4zLDAgMTIuOCw1LjUgMTIuOCwxMi4yYzAsNi4xIC0zLjYsOS40IC02LjQsMTAuN2w2LjQsMTIuNWwtMTIuMiwwem0tMi4zLC0yNi41bC02LjUsMGwwLDYuMmw2LjUsMGMxLjgsMCAzLjUsLTEuMiAzLjUsLTMuMWMwLC0yIC0xLjcsLTMuMSAtMy41LC0zLjF6IiBjbGFzcz0ic3QxIi8+CiAgICAgPHBhdGggaWQ9InN2Z18xNiIgZmlsbD0iIzFDMzAzNyIgZD0ibTEwOS4wNTU1NSw4Ny4xNTU1NWwwLC0zNS40bDEwLjcsMGwwLDM1LjRsLTEwLjcsMHoiIGNsYXNzPSJzdDEiLz4KICAgICA8cGF0aCBpZD0ic3ZnXzE3IiBmaWxsPSIjMUMzMDM3IiBkPSJtMTI4LjM1NTU1LDc0LjE1NTU1YzIuNywyLjUgNi42LDQuNiAxMS40LDQuNmMyLDAgMy45LC0wLjcgMy45LC0yLjFzLTEuNSwtMi4xIC01LC0yLjdjLTUuOCwtMS4xIC0xNC44LC0yLjQgLTE0LjgsLTExLjNjMCwtNiA1LC0xMS41IDE0LjcsLTExLjVjNS44LDAgMTEsMS42IDE1LDQuOWwtNS43LDcuNmMtMy4xLC0yLjMgLTcuMSwtMy41IC05LjksLTMuNWMtMi43LDAgLTMuMiwxIC0zLjIsMS45YzAsMS40IDEuNCwxLjkgNS4yLDIuNWM1LjgsMSAxNC41LDIuNyAxNC41LDEwLjljMCw3LjggLTUuOCwxMi4zIC0xNS4zLDEyLjNjLTcuNSwwIC0xMi43LC0yLjIgLTE2LjUsLTUuNmw1LjcsLTh6IiBjbGFzcz0ic3QxIi8+CiAgICAgPHBhdGggaWQ9InN2Z18xOCIgZmlsbD0iIzFDMzAzNyIgZD0ibTE1Ni4xNTU1NSw2OS40NTU1NWMwLC0xMC45IDguNCwtMTguMyAxOS4yLC0xOC4zYzkuNiwwIDE0LjIsNS40IDE2LjQsMTAuM2wtOS4yLDQuM2MtMC45LC0yLjggLTMuNywtNS4yIC03LjEsLTUuMmMtNC45LDAgLTguMywzLjkgLTguMyw4LjljMCw0LjkgMy41LDguOSA4LjMsOC45YzMuNSwwIDYuMiwtMi40IDcuMSwtNS4ybDkuMiw0LjNjLTIuMSw0LjcgLTYuOCwxMC40IC0xNi40LDEwLjRjLTEwLjgsLTAuMSAtMTkuMiwtNy41IC0xOS4yLC0xOC40eiIgY2xhc3M9InN0MSIvPgogICAgIDxwYXRoIGlkPSJzdmdfMTkiIGZpbGw9IiMxQzMwMzciIGQ9Im0yMTIuNTU1NTUsNTEuMTU1NTVjMTAuOSwwIDE5LjQsNy40IDE5LjQsMTguM2MwLDEwLjkgLTguNCwxOC4zIC0xOS40LDE4LjNjLTEwLjksMCAtMTkuNCwtNy40IC0xOS40LC0xOC4zYzAuMSwtMTAuOSA4LjUsLTE4LjMgMTkuNCwtMTguM3ptMCw5LjRjLTUuMiwwIC04LjUsMy45IC04LjUsOC45YzAsNC45IDMuMyw4LjkgOC41LDguOWM1LjIsMCA4LjUsLTMuOSA4LjUsLTguOWMwLC01IC0zLjMsLTguOSAtOC41LC04Ljl6IiBjbGFzcz0ic3QxIi8+CiAgICAgPHBhdGggaWQ9InN2Z18yMCIgZmlsbD0iIzFDMzAzNyIgZD0ibTIzNS44NTU1NSw4Ny4xNTU1NWwwLC0zNS40bDE4LjksMGM4LjMsMCAxMi44LDUuNSAxMi44LDEyLjJjMCw2LjYgLTQuNSwxMS45IC0xMi44LDExLjlsLTguMiwwbDAsMTEuNGwtMTAuNywwbDAsLTAuMXptMTcuNSwtMjYuNWwtNi44LDBsMCw2LjJsNi44LDBjMS44LDAgMy4yLC0xLjIgMy4yLC0zLjFjMCwtMS45IC0xLjQsLTMuMSAtMy4yLC0zLjF6IiBjbGFzcz0ic3QxIi8+CiAgICAgPHBhdGggaWQ9InN2Z18yMSIgZmlsbD0iIzFDMzAzNyIgZD0ibTI3MC45NTU1NSw4Ny4xNTU1NWwwLC0zNS40bDI2LjksMGwwLDguOWwtMTYuMiwwbDAsNC4xbDE1LjksMGwwLDguOWwtMTUuOCwwbDAsNC41bDE2LjIsMGwwLDguOWwtMjcsMGwwLDAuMXoiIGNsYXNzPSJzdDEiLz4KICAgIDwvZz4KICAgIDxnIGlkPSJzdmdfMjIiPgogICAgIDxnIGlkPSJzdmdfMjMiPgogICAgICA8cGF0aCBpZD0ic3ZnXzI0IiBmaWxsPSIjNkM4RDc1IiBkPSJtMjk1LjU1NTU1LDQ2LjQ1NTU1bDAsLTMyLjljMCwtMC43IC0wLjYsLTEuMyAtMS4zLC0xLjJjLTE3LjksMS4yIC0zMiwxNiAtMzIuMSwzNC4xYzAsMC43IDAuNSwxLjIgMS4yLDEuMmwzMSwwYzAuNywwIDEuMiwtMC41IDEuMiwtMS4yeiIgY2xhc3M9InN0MiIvPgogICAgIDwvZz4KICAgICA8ZyBpZD0ic3ZnXzI1Ij4KICAgICAgPHBhdGggaWQ9InN2Z18yNiIgZmlsbD0iIzZDOEQ3NSIgZD0ibTMwMS42NTU1NSw0Ny42NTU1NWwzMSwwYzAuNywwIDEuMiwtMC41IDEuMiwtMS4yYy0wLjEsLTE4LjEgLTE0LjMsLTMyLjkgLTMyLjEsLTM0LjFjLTAuNywwIC0xLjMsMC41IC0xLjMsMS4ybDAsMzIuOWMwLDAuNyAwLjYsMS4yIDEuMiwxLjJ6IiBjbGFzcz0ic3QyIi8+CiAgICAgPC9nPgogICAgIDxnIGlkPSJzdmdfMjciPgogICAgICA8cGF0aCBpZD0ic3ZnXzI4IiBmaWxsPSIjNkM4RDc1IiBkPSJtMzAwLjQ1NTU1LDUyLjc1NTU1bDAsMjguOWMwLDAuNyAwLjYsMS4zIDEuMywxLjJjMTYuNSwtMS4xIDI5LjksLTEzLjggMzEuOSwtMzBjMC4xLC0wLjcgLTAuNSwtMS4zIC0xLjIsLTEuM2wtMzAuNywwYy0wLjcsMCAtMS4zLDAuNiAtMS4zLDEuMnoiIGNsYXNzPSJzdDIiLz4KICAgICA8L2c+CiAgICA8L2c+CiAgICA8ZyBpZD0ic3ZnXzI5Ij4KICAgICA8ZyBpZD0ic3ZnXzMwIj4KICAgICAgPGxpbmUgaWQ9InN2Z18zMSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZT0iI0ZGRkZGRiIgZmlsbD0ibm9uZSIgeTI9IjQxLjU1NTU1IiB4Mj0iMjgyLjI1NTU1IiB5MT0iNDEuNTU1NTUiIHgxPSIyNzUuOTU1NTUiIGNsYXNzPSJzdDMiLz4KICAgICA8L2c+CiAgICAgPGcgaWQ9InN2Z18zMiI+CiAgICAgIDxsaW5lIGlkPSJzdmdfMzMiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2U9IiNGRkZGRkYiIGZpbGw9Im5vbmUiIHkyPSIzNi44NTU1NSIgeDI9IjI4Mi4yNTU1NSIgeTE9IjM2Ljg1NTU1IiB4MT0iMjc0LjA1NTU1IiBjbGFzcz0ic3QzIi8+CiAgICAgPC9nPgogICAgIDxnIGlkPSJzdmdfMzQiPgogICAgICA8bGluZSBpZD0ic3ZnXzM1IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSIjRkZGRkZGIiBmaWxsPSJub25lIiB5Mj0iMzIuMzU1NTUiIHgyPSIyODIuMjU1NTUiIHkxPSIzMi4zNTU1NSIgeDE9IjI3OC4yNTU1NSIgY2xhc3M9InN0MyIvPgogICAgIDwvZz4KICAgICA8ZyBpZD0ic3ZnXzM2Ij4KICAgICAgPGxpbmUgaWQ9InN2Z18zNyIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZT0iI0ZGRkZGRiIgZmlsbD0ibm9uZSIgeTI9IjI4LjA1NTU1IiB4Mj0iMjgyLjI1NTU1IiB5MT0iMjguMDU1NTUiIHgxPSIyNzUuNzU1NTUiIGNsYXNzPSJzdDMiLz4KICAgICA8L2c+CiAgICA8L2c+CiAgICA8ZyBpZD0ic3ZnXzM4Ij4KICAgICA8ZyBpZD0ic3ZnXzM5Ij4KICAgICAgPHBhdGggaWQ9InN2Z180MCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjQiIHN0cm9rZT0iIzFDMzAzNyIgZmlsbD0ibm9uZSIgZD0ibTI5My41NTU1NSw3LjA1NTU1Yy0yMi4xLDIuMyAtMzQuNSwxOS4xIC0zNi44LDM4LjYiIGNsYXNzPSJzdDQiLz4KICAgICA8L2c+CiAgICAgPGcgaWQ9InN2Z180MSI+CiAgICAgIDxwYXRoIGlkPSJzdmdfNDIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSI0IiBzdHJva2U9IiMxQzMwMzciIGZpbGw9Im5vbmUiIGQ9Im0zMzkuMzU1NTUsNDUuNjU1NTVjLTEsLTIyLjQgLTE2LjgsLTM3LjUgLTM2LjksLTM4LjciIGNsYXNzPSJzdDQiLz4KICAgICA8L2c+CiAgICAgPGcgaWQ9InN2Z180MyI+CiAgICAgIDxwYXRoIGlkPSJzdmdfNDQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSI0IiBzdHJva2U9IiMxQzMwMzciIGZpbGw9Im5vbmUiIGQ9Im0zMDIuNTU1NTUsODguMzU1NTVjMjAuMiwtMS4zIDM1LjMsLTEzLjkgMzYuOSwtMzQuOSIgY2xhc3M9InN0NCIvPgogICAgIDwvZz4KICAgIDwvZz4KICAgPC9nPgogIDwvZz4KIDwvZz4KPC9zdmc+'
  : '/img/mp-logo.svg';

const Header = ({
  componentName,
  initialTag,
  subcategories,
  parentItm,
  title,
  isFullBar,
  isModifiedHeaderOnPrint,
  className,
}) => {
  const breakpointIndex = useBreakpointIndex();
  const {
    isSearchActive,
    percentOfCoveredTitle,
    isLogged,
    user,
    isNavActive,
    setIsNavActive,
    isLoginFormActive,
    setIsLoginFormActive,
    authButton,
    currentHref,
    isContentCropped,
  } = useGlobalContext();

  const header = useRef();
  const [isHeaderStuck, setIsHeaderStuck] = useState(false);
  const [csrfToken] = useState(null);

  useEffect(() => {
    if (!header.current) return;

    const cachedHeader = header.current;

    const observer = new IntersectionObserver(
      ([e]) => {
        setIsHeaderStuck(e.intersectionRatio < NOT_COVERED_TITLE_PERCENTS);
      },
      { threshold: 1.0 },
    );

    observer.observe(cachedHeader);
    return () => observer.unobserve(cachedHeader);
  }, [header]);

  const closeAuthModals = () => {
    setIsLoginFormActive(false);
  };

  const isShownPrintBtn = strictMathUrl(componentName, PRINTED_PAGES);
  const shouldApplyFlexGrowToMidWrapper = !isFullBar;

  const isMiniBarActive =
    percentOfCoveredTitle < NOT_COVERED_TITLE_PERCENTS || !isFullBar;
  const isMidWrapperAlignedLeft =
    percentOfCoveredTitle >= NOT_COVERED_TITLE_PERCENTS && !isSearchActive;
  const isCategoryNavigationDisplayed =
    percentOfCoveredTitle < NOT_COVERED_TITLE_PERCENTS;
  const isMobile = breakpointIndex <= MOBILE_BREAKPOINT_INDEX;

  const { handlePrint } = usePrint(user, isShownPrintBtn);

  return (
    <Container
      $isStuck={isHeaderStuck}
      $isModifiedHeaderOnPrint={isModifiedHeaderOnPrint}
      ref={header}
      className={className}
    >
      <LogoWrapper $isModifiedHeaderOnPrint={isModifiedHeaderOnPrint}>
        <UniversalLink href='/' passHref>
          <NoUnderlineAnchor>
            <LinkImage
              width={175}
              height={45}
              src={mpLogo}
              alt='Military Periscope Logo'
              quality={100}
              layout='responsive'
              priority
            />
          </NoUnderlineAnchor>
        </UniversalLink>
      </LogoWrapper>

      {isLoginFormActive ? (
        <CloseLoginIcon
          onClick={closeAuthModals}
          className={styles.hideForPrint}
        />
      ) : (
        <>
          {!isMobile && (
            <MidWrapper
              className={styles.hideForPrint}
              $isMiniBarActive={isMiniBarActive}
              $isAlignedLeft={isMidWrapperAlignedLeft}
              $isStuck={isHeaderStuck}
              $shouldGrow={shouldApplyFlexGrowToMidWrapper}
            >
              {isCategoryNavigationDisplayed && (
                <HeaderCategoryNavigation
                  parentItm={parentItm}
                  title={title}
                  opacity={NOT_COVERED_TITLE_PERCENTS - percentOfCoveredTitle}
                />
              )}
              <SearchAndPrintWrapper $isStuck={isHeaderStuck}>
                {isLogged && (
                  <SearchBar
                    initialTag={initialTag}
                    componentName={componentName}
                    isFullBar={isFullBar}
                    subcategories={subcategories}
                  />
                )}
                {!isContentCropped && isShownPrintBtn && (
                  <PrintButton
                    user={user}
                    isFullBar={isFullBar}
                    className={styles.hideForPrint}
                    handlePrint={handlePrint}
                  />
                )}
              </SearchAndPrintWrapper>
            </MidWrapper>
          )}

          <MidWrapper
            $isMiniBarActive={isMiniBarActive}
            $isAlignedLeft={false}
            className={[styles.hideForNoPrint, styles.displayOnPrint].join(' ')}
            $isStuck={true}
            $shouldGrow={shouldApplyFlexGrowToMidWrapper}
          >
            <HeaderCategoryNavigation
              parentItm={parentItm}
              title={title}
              isModifiedHeaderOnPrint={isModifiedHeaderOnPrint}
              pageTitleClassName={styles.hideForPrint}
              opacity={1}
            />
          </MidWrapper>

          {isMobile && !isContentCropped && isShownPrintBtn && (
            <PrintButton
              user={user}
              className={styles.hideForPrint}
              handlePrint={handlePrint}
            />
          )}

          <Auth className={styles.hideForPrint}>
            {isLogged ? (
              <>
                {(user.userLevel === TRIAL_USER_LEVEL ||
                  user.userLevel === FREE_USER_LEVEL) && (
                  <UpgradeTrialButton pageTitle={title} />
                )}
                <form>
                  <input
                    type='hidden'
                    name='csrfmiddlewaretoken'
                    value={csrfToken || ''}
                  />
                  <AuthButton
                    formMethod='post'
                    formAction={`/accounts/auth0/logout/?returnTo=${HOST_ENV}`}
                    type='submit'
                  >
                    Log out
                  </AuthButton>
                </form>
              </>
            ) : (
              <>
                <form>
                  <input
                    type='hidden'
                    name='csrfmiddlewaretoken'
                    value={csrfToken || ''}
                  />
                  <input type='hidden' name='next' value={currentHref || ''} />
                  <AuthButton
                    ref={authButton}
                    formMethod='get'
                    formAction='/accounts/auth0/login/'
                    type='submit'
                  >
                    Login
                  </AuthButton>
                </form>
                <UniversalLink href={FREE_TRIAL_URL}>
                  <AlignedGreenButton>Try it Free</AlignedGreenButton>
                </UniversalLink>
              </>
            )}
            {isNavActive ? (
              <MenuLabelContainer
                onClick={() => setIsNavActive(false)}
                className={styles.hideForPrint}
              >
                <IconContainer>
                  <CloseNavIcon />
                </IconContainer>
                {!isMobile && <MenuLabel>Menu</MenuLabel>}
              </MenuLabelContainer>
            ) : (
              <MenuLabelContainer
                onClick={() => setIsNavActive(true)}
                className={styles.hideForPrint}
              >
                <IconContainer>
                  <NavIcon />
                </IconContainer>
                {!isMobile && <MenuLabel>Menu</MenuLabel>}
              </MenuLabelContainer>
            )}
          </Auth>

          {isMobile && isLogged && (
            <SearchBar
              className={styles.hideForPrint}
              initialTag={initialTag}
              componentName={componentName}
              isFullBar={isFullBar}
              subcategories={subcategories}
            />
          )}
        </>
      )}
    </Container>
  );
};

export default Header;
